import { object } from '@calendly/form/validation'

import {
  formatGuestsAllowedValues,
  formatInviteeQuestionsValues,
  getGuestsAllowedInitialValues,
  getInviteeQuestionsInitialValues,
  getInviteeQuestionsValidationSchema
} from 'components/event_type_edit'

const getLocationInitialValues = (eventType) => ({
  locationLabel: eventType.location_label,
  locationConfigurations: eventType.location_configurations,
})

export const getInitialValues = (eventType) => {
  const guestsAllowedInitialValues = !eventType.isGroup ? getGuestsAllowedInitialValues(eventType) : {}

  return ({
    nameFormat: eventType.invitee_name_format,
    bookingAutofill: eventType.booking_autofill,
    ...guestsAllowedInitialValues,
    ...getLocationInitialValues(eventType),
    ...getInviteeQuestionsInitialValues(eventType),
  })
}

const formatLocationValues = (values) => ({
  location_label: values.locationLabel,
  location_configurations_attributes: values.locationConfigurations.map((locationConfiguration, index) => ({
    ...locationConfiguration,
    position: index,
  }))
})

const formatInviteeFormValues = (values) => ({
  invitee_name_format: values.nameFormat,
  booking_autofill: values.bookingAutofill,
  ...formatLocationValues(values),
  ...formatInviteeQuestionsValues(values),
})

export const getFormatValuesToServerData = (eventType) => (values) => {
  const guestsAllowedValues = !eventType.isGroup ? formatGuestsAllowedValues(values) : {}

  return {
    ...guestsAllowedValues,
    ...formatInviteeFormValues(values)
  }
}

export const getValidationSchema = () => object({})
  .concat(getInviteeQuestionsValidationSchema())
